import { getDictionarySelectProps } from 'features/shared/utility/dictionarySelectHelper';
import React, { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { RMSSelect } from '../../../shared/components/form-controls';
import SearchPersonAutoComplete from '../../../shared/components/modules/SearchPersonAutoComplete';
import SearchPlaceAutoComplete from '../../../shared/components/modules/SearchPlaceAutoComplete';
import { PARTY_KIND, PARTY_KIND_OPTIONS } from '../../constants/partyKindLookupConstants';

const PartyKindLookup = ({ typeFieldName, idFieldName, typeLabel, idLabel, idValue }) => {
  const { control, setValue } = useFormContext();
  const partyKind = useWatch({ control, name: typeFieldName });

  const handlePersonCreated = useCallback(
    (person) => {
      setValue(idFieldName, person?.ptsPersonID ?? null, {
        shouldDirty: true,
        shouldValidate: true,
      });
    },
    [idFieldName, setValue]
  );

  const handlePlaceCreated = useCallback(
    (place) => {
      setValue(idFieldName, place?.ptsPlaceID ?? null, {
        shouldDirty: true,
        shouldValidate: true,
      });
    },
    [idFieldName, setValue]
  );

  return (
    <>
      <Grid item xs={6}>
        <RMSSelect
          name={typeFieldName}
          label={typeLabel}
          options={PARTY_KIND_OPTIONS}
          {...getDictionarySelectProps({ optionLabel: 'Code', showLabelOnly: true })}
          onChange={() => setValue(idFieldName, null)}
        />
      </Grid>
      <Grid item xs={6}>
        {partyKind === PARTY_KIND.PLACE && (
          <SearchPlaceAutoComplete
            name={idFieldName}
            label={idLabel}
            defaultPlaceId={idValue}
            onPlaceCreated={handlePlaceCreated}
            onPlaceUpdated={handlePlaceCreated}
            showDetailsIcon={false}
          />
        )}
        {partyKind === PARTY_KIND.PERSON && (
          <SearchPersonAutoComplete
            name={idFieldName}
            label={idLabel}
            defaultPersonId={idValue}
            onPersonCreated={handlePersonCreated}
            showDetailsIcon={false}
          />
        )}
      </Grid>
    </>
  );
};

export default PartyKindLookup;
